import { SlWapiService } from '../model/api-services/sl-wapi.service';
import { SLLayer } from '../model/sl-layer';
import { AnyHandler } from '../types/@types/sl-v-types';
import { ModalMessagerService } from './../modal-messager/modal-messager.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GalleryExportService {

  constructor(private wapi: SlWapiService) { }
  ExportGallery(messager: ModalMessagerService,
    fileName: string,
    layer: SLLayer,
    columns:Array<string>,
    data: Array<any> | '*',
    handler?: AnyHandler
  ) {
    const gids: string = data === '*' ? '*' : SLLayer.GetGids(data, true) as string;
    const params: any = {
      features: (gids),
      columns:columns[0] === '*' ? '*' : columns.join(',')
    }
    if (layer.isPLayer === true) {
      params.plid = layer.plid;
    } else {
      params.lid = layer.id;
    }
    params.labelitem = layer.labelAttribute;

    messager.RequestDownload(
      {
        extension: 'zip',
        mimeType: 'application/zip',
        defaultFileName: fileName
      },
      'layers/download/gallery/get',
      params,
      'Export image gallery  to zip',
      handler);
    // this.wapi.DownloadFile('layers/download/kml/', params, 'application/vnd', fileName);
  }
}
